export const TRIP_LIST = "TRIP_LIST";
export const TRIP_DETAILS = "TRIP_DETAILS";
export const TRIP_QUERY = "TRIP_QUERY";
export const TRIP_LOADING = "TRIP_LOADING";
export const RESET_TRIP = "RESET_TRIP";
